import { useAppSelector, useAppDispatch, uiActions } from '../store/index'
import { authService } from '../services/authService'

export function useAuth() {
  const dispatch = useAppDispatch()
  const isAuthenticated = useAppSelector(state => state.ui.isAuthenticated)
  const userRole = useAppSelector(state => state.ui.userRole)
  const token = useAppSelector(state => state.ui.token)
  const loggedInRunnerId = useAppSelector(state => state.ui.loggedInRunnerId)
  const loggedInRunnerNumber = useAppSelector(state => state.ui.loggedInRunnerNumber)

  const login = async (username: string, password: string) => {
    const result = await authService.login(username, password)
    localStorage.setItem('login_time', String(Date.now()))
    dispatch(uiActions.setAuthenticated({
      token: result.token,
      role: result.role,
      username,
      runnerId: result.runnerId ?? null,
      runnerNumber: result.runnerNumber ?? null,
    }))
    return result
  }

  const logout = async () => {
    await authService.logout()
    dispatch(uiActions.logout())
  }

  return {
    isAuthenticated,
    userRole,
    token,
    loggedInRunnerId,
    loggedInRunnerNumber,
    login,
    logout,
    isAdmin: userRole === 'race_organizer' || userRole === 'team_admin',
    isRunner: userRole === 'runner',
  }
}
